import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";
import { MenuItem } from "@mui/material";
Sentry.init({
    dsn: "https://0c6e576b424af1b768759fdae21c8d8f@o4508939407130624.ingest.us.sentry.io/4508939432034304",
    beforeSend(event, hint) {
        // Check if it is an exception, and if so, show the report dialog
        if (event.exception && event.event_id) {
            Sentry.showReportDialog({ eventId: event.event_id, user: event.user });
        }
        return event;
    },
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration(
            {
                maskAllText: false,
                blockAllMedia: false,
            }
        ),
        Sentry.feedbackIntegration({
            colorScheme: "system",
            isNameRequired: true,
            autoInject: false,
            useSentryUser: {
                name: "name",
                email: "email",
            }
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/apis\.profitmaxprosuite\.com/],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.02,
    replaysOnErrorSampleRate: 1.0,
});

export function MyFeedbackButton({ onClick }) {
    const client = Sentry.getClient();
    const feedback = client?.getIntegrationByName("Feedback");

    React.useEffect(() => {
        if (feedback) {
            feedback.attachTo(document.querySelector("#FEEDBACK_BUTTON"), {
                formTitle: "Report a Bug!",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <MenuItem id="FEEDBACK_BUTTON" onClick={onClick}>
            Report a Bug
        </MenuItem>
    );
} 